import { z } from 'zod';

import { commonErrors } from '@utils/error';
import { doesNotExist } from '@utils/general';
import { checkbox, commonParams, optionalString, superRefineHelper } from '@utils/validation';
import { IMemberTestosteroneGoalsPageContent } from '@ui/routes/MemberTestosterone/MemberTestosteroneGoalsStep/MemberTestosteroneGoalsStep.component';

export const testContent: IMemberTestosteroneGoalsPageContent = {
	pageHeader: 'What changes are you most excited for?',
	pageInfo: `Everyone's journey looks different. Knowing the changes you are excited about helps us prescribe medication(s) that best fits you. Select all that apply.
	You can discuss your unique goals, and any changes you don't want, with your clinician during your virtual appointment.`,

	hrtGoalsEmotionalBenefits: 'Emotional benefits',
	hrtGoalsGenderEuphoria: 'Gender euphoria',
	hrtGoalsDeepenVoice: 'Deepen voice',
	hrtGoalsImproveLibido: 'Improve libido & sexual satisfaction',
	hrtGoalsBottomGrowth: 'Bottom growth',
	hrtGoalsRedistributeFat: 'Body fat distribution',
	hrtGoalsMuscleStrength: 'Muscle strength',
	hrtGoalsChestChange: 'Chest tissue change',
	hrtGoalsBodyHair: 'Increase body hair',
	hrtGoalsFacialHair: 'Increase facial hair',

	hrtGoalsOther: 'Other',
};

export const schema = z
	.object({
		hrtGoalsEmotionalBenefits: checkbox,
		hrtGoalsGenderEuphoria: checkbox,
		hrtGoalsDeepenVoice: checkbox,
		hrtGoalsImproveLibido: checkbox,
		hrtGoalsBottomGrowth: checkbox,
		hrtGoalsRedistributeFat: checkbox,
		hrtGoalsMuscleStrength: checkbox,
		hrtGoalsChestChange: checkbox,
		hrtGoalsBodyHair: checkbox,
		hrtGoalsFacialHair: checkbox,
		hrtGoalsOther: checkbox,
		hrtGoalsOtherText: optionalString,
	})
	.superRefine((data, ctx) => {
		const params = commonParams(data, ctx);

		if (data.hrtGoalsOther) {
			superRefineHelper({
				...params,
				dataPath: 'hrtGoalsOtherText',
				negativeCondition: doesNotExist,
				message: commonErrors.inputRequired,
			});
		}
	});
